import React, { useContext, useEffect, useState } from 'react';
import { Menu } from 'antd';
import { useLocation, NavLink } from 'react-router-dom';
import { FileTextFilled, HomeFilled, QuestionCircleFilled, SettingFilled } from '@ant-design/icons';
import { UserContext } from '../contexts';
import { hasAdminPageRole, hasReportsPageRole, hasMatricesPageRole } from '../../utils';

export function Navigation() {
  const { pathname } = useLocation();
  const [path, setPath] = useState('');
  const { user } = useContext(UserContext);

  useEffect(() => {
    const path = '/' + pathname.split('/')[1];
    setPath(path);
  }, [pathname]);

  return (
    <>
      <Menu theme="dark" mode="horizontal" selectedKeys={[path]} style={{ backgroundColor: '#294D78', textAlign: 'right' }}>
        <Menu.Item icon={<HomeFilled />} key="/">
          <NavLink to="/">Ana sayfa</NavLink>
        </Menu.Item>
        {hasReportsPageRole(user) && (
          <Menu.Item icon={<FileTextFilled />} key="/reports">
            <NavLink to="/reports">Raporlar</NavLink>
          </Menu.Item>
        )}
        {hasMatricesPageRole(user) && (
          <Menu.Item icon={<SettingFilled />} key="/qa-matrix">
            <NavLink to="/qa-matrix">QA Matris</NavLink>
          </Menu.Item>
        )}
        {hasAdminPageRole(user) && (
          <Menu.Item icon={<SettingFilled />} key="/admin">
            <NavLink to="/admin">Yönetim</NavLink>
          </Menu.Item>
        )}
        {!user && (
          <Menu.Item icon={<QuestionCircleFilled />} key="/help">
            <NavLink to="/help">Yardım</NavLink>
          </Menu.Item>
        )}
      </Menu>
    </>
  );
}
